import {
  applyMiddleware,
  combineReducers,
  createStore,
  compose
} from 'redux';
import thunk from 'redux-thunk';
import trackUserActivity from '../lib/trackUserActivity';

import authReducer from './reducers/authReducer';
import chatReducer from './reducers/chatReducer';
import contentReducer from './reducers/contentReducer';
import studioReducer from './reducers/studioReducer';

const rootReducer = combineReducers({
  content: contentReducer,
  auth: authReducer,
  chat: chatReducer,
  studio: studioReducer
});

const middlewareEnhancer = applyMiddleware(trackUserActivity, thunk);
const trueCompose = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  : compose

export const store = createStore(
  rootReducer,
  trueCompose(middlewareEnhancer)
);

export default store;
